import React, { useState, useCallback, useEffect } from 'react';
import Campaign, { CampaignType } from '../components/Campaign';
import { ArrowBackIosNew } from '@mui/icons-material';
import { ArrowForwardIos } from '@mui/icons-material';
import AddIcon from '@mui/icons-material/Add';
import { useDataContext } from '../data/DataContext';

const AdminPage: React.FC = (): React.ReactElement => {
    const [currentCampaignIndex, setCurrentCampaignIndex] = useState<number>(0);
    
    const { fetchCampaigns, updateCampaign, campaigns, createNewCampaign, deleteCampaignAndFetch } = useDataContext();
    
    const [campaignList, setCampaignList] = useState<CampaignType[]>([]);
    
    const noPreviousCampaign = currentCampaignIndex === 0;
    const noNextCampaign = currentCampaignIndex === campaignList.length - 1;
    
    useEffect(() => {
        if (campaigns.length === 0) {
            fetchCampaigns();
        };
    }, []);

    useEffect(() => {
        setCampaignList(campaigns || []);
    }, [campaigns]);

    const setCampaign = useCallback(
        (campaign: CampaignType) => {
            const campaignListCopy = [...campaignList];
            campaignListCopy[currentCampaignIndex] = campaign;
            setCampaignList([...campaignListCopy]);
            updateCampaign(campaign);
        },
        [campaignList, currentCampaignIndex, updateCampaign]
    );

    const addNewCampaign = async () => {
        if (window.confirm('Sind Sie sicher, dass Sie eine neue Kampagne erstellen möchten?')) {
            createNewCampaign();
            setCurrentCampaignIndex(campaignList.length);
        }
    };

    const previousCampaign = () => {
        setCurrentCampaignIndex(currentCampaignIndex - 1);
    };

    const nextCampaign = () => {
        setCurrentCampaignIndex(currentCampaignIndex + 1);
    };

    const handleDelete = async () => {
        if (window.confirm('Sind Sie sicher, dass Sie diese Kampagne löschen möchten?')) {
            deleteCampaignAndFetch(campaignList[currentCampaignIndex].id);
            setCurrentCampaignIndex(0);
        }
    }


    return (
        <div className="admin">
            {campaignList.length !== 0 && <>
                    <Campaign 
                    campaign={campaignList[currentCampaignIndex]} 
                    setCampaign={setCampaign}
                    handleDelete={handleDelete}
                    />
                    <p className="campaign-nav">
                        <button className="icon-desc-button clear" disabled={noPreviousCampaign} onClick={previousCampaign}>
                            <ArrowBackIosNew/>
                        </button>
                        {currentCampaignIndex + 1} / {campaignList.length}
                        <button className="icon-desc-button clear" disabled={noNextCampaign} onClick={nextCampaign}>
                            <ArrowForwardIos/>
                        </button>
                    </p>
            </> }
            <button className="icon-desc-button clear no-campaigns" onClick={addNewCampaign}>
                <AddIcon/>
                Neue Kampagne erstellen
            </button>
        </div>
    );
};

export default AdminPage;